import React from "react";
import { CSVLink } from "react-csv";

import { MDBBtn } from "mdb-react-ui-kit";

const ExportToCSV = (props) => {
   let data = React.useMemo(() => {
      return props.reports.map((d) => Object.values(d));
   }, []);

   let dataString = JSON.stringify(data);

   if (props.type === "Free Service List") {
      data = JSON.parse(
         dataString.substring(0, 1) +
         `["Unit Serial No.",
        "Vehicle No.",
        "Model No.",
        "Customer Name",
        "Address",
        "Date of Installation",
        "Month Difference"],` +
         dataString.substring(1)
      );
   } else if (props.type === "Warranty Parts Reimbursement") {
      data = JSON.parse(
         dataString.substring(0, 1) +
         `["Job Card No.",
            "Service Request No.",
            "Part No.",
            "Part Name",
            "Quantity",
            "Quantity Unit"],` +
         dataString.substring(1)
      );
   }

   const date = new Date();
   return (
      <CSVLink data={data} filename={props.monthYear + " - " + props.type + " - report as on " + date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear() + ".csv"}>
         <MDBBtn>Download as CSV</MDBBtn>
      </CSVLink>
   );
}

export default ExportToCSV;
